import React from "react";
import { useRouter } from "../../hooks/useRouter";
import { getIsAdmin } from "../../utils/api/admin";
import { useViewport } from "../../hooks/useViewport";

interface IIdentityContext {
  isAdmin: boolean;
  isFromExtension: boolean;
  isLoading: boolean;
}

export const identityContext = React.createContext<IIdentityContext>({
  isAdmin: false,
  isFromExtension: false,
  isLoading: true,
});

export const IdentityProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [isFromExtension, setIsFromExtension] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const { query }: { query: { [key: string]: string } } = useRouter();
  const { isAppOpened } = useViewport();
  React.useEffect(() => {
    if (!isAppOpened) return;
    // TODO: set invite function
    getIsAdmin().then((res) => {
      setIsAdmin(res);
      if (!!query.isExtension) setIsFromExtension(true);
      setIsLoading(false);
    });
  }, [isAppOpened]);

  return (
    <identityContext.Provider value={{ isAdmin, isFromExtension, isLoading }}>
      {children}
    </identityContext.Provider>
  );
};
